const INDUSTRIES_EN = [
  { id: 0, slug: 'restaurants-bars', label: 'Restaurants & Bars' },
  { id: 1, slug: 'food-beverages', label: 'Food and beverages' },
  { id: 2, slug: 'electronics-software', label: 'Electronics and Software' },
  {
    id: 3,
    slug: 'telecom-internet',
    label: 'Telephones, Cell Phones & Internet services'
  },
  {
    id: 4,
    slug: 'entertainment-events-tickets',
    label: 'Entertainment, events & tickets'
  },
  {
    id: 5,
    slug: 'books-games-movies-music',
    label: 'Books, games, toys, movies & music'
  },
  { id: 6, slug: 'clothing-store', label: 'Fashion & accessories' },
  { id: 7, slug: 'fitness-sports', label: 'Fitness & Sports' },
  { id: 8, slug: 'health-beauty', label: 'Health & beauty' },
  { id: 9, slug: 'education', label: 'Education' },
  { id: 10, slug: 'culture', label: 'Culture' },
  {
    id: 11,
    slug: 'tourism-hotels-accommodation',
    label: 'Tourism, Hotels & accommodation'
  },
  { id: 12, slug: 'pet-related', label: 'Pets' },
  {
    id: 13,
    slug: 'stationery-office',
    label: 'Office supplies & stationery'
  },
  { id: 14, slug: 'home', label: 'Home & furniture' },
  { id: 15, slug: 'services', label: 'Services' },
  { id: 16, slug: 'other', label: 'Other' }
]

const SHORT_INDUSTRIES_EN = [
  { id: 0, slug: 'restaurants-bars', label: 'Restaurants & Bars' },
  { id: 1, slug: 'food-beverages', label: 'Food and beverages' },
  {
    id: 2,
    slug: 'books-games-movies-music',
    label: 'Books, games, toys, movies & music'
  },
  { id: 3, slug: 'clothing-store', label: 'Fashion & accessories' }
]

const INDUSTRIES_ES = [
  { id: 0, slug: 'restaurants-bars', label: 'Restaurantes y Bares' },
  { id: 1, slug: 'food-beverages', label: 'Alimentos y bebidas' },
  { id: 2, slug: 'electronics-software', label: 'Electrónica y Software' },
  { id: 3, slug: 'telecom-internet', label: 'Telefonía, Celular e Internet' },
  {
    id: 4,
    slug: 'entertainment-events-tickets',
    label: 'Entretenimiento, eventos y boletos'
  },
  {
    id: 5,
    slug: 'books-games-movies-music',
    label: 'Libros, juegos, juguetes, películas y música'
  },
  { id: 6, slug: 'clothing-store', label: 'Moda y accesorios' },
  { id: 7, slug: 'fitness-sports', label: 'Fitness y Deportes' },
  { id: 8, slug: 'health-beauty', label: 'Salud y belleza' },
  { id: 9, slug: 'education', label: 'Educación' },
  { id: 10, slug: 'culture', label: 'Cultura' },
  {
    id: 11,
    slug: 'tourism-hotels-accommodation',
    label: 'Turismo, Hoteles y alojamientos'
  },
  { id: 12, slug: 'pet-related', label: 'Mascotas' },
  { id: 13, slug: 'stationery-office', label: 'Oficina y Papelería' },
  { id: 14, slug: 'home', label: 'Casa y Hogar' },
  { id: 15, slug: 'services', label: 'Servicios' },
  { id: 16, slug: 'other', label: 'Otro' }
]

const SHORT_INDUSTRIES_ES = [
  { id: 0, slug: 'restaurants-bars', label: 'Restaurantes y Bares' },
  { id: 1, slug: 'food-beverages', label: 'Alimentos y bebidas' },
  {
    id: 2,
    slug: 'books-games-movies-music',
    label: 'Libros, juegos, juguetes, películas y música'
  },
  { id: 3, slug: 'clothing-store', label: 'Moda y accesorios' }
]

const handleSpecificLabelCategory = (lang, category) => {
  const industries = lang === 'ES' ? INDUSTRIES_ES : INDUSTRIES_EN
  const arr = []
  industries.forEach((item) => {
    arr.push(item.slug)
  })

  if (arr.includes(category)) {
    let label = ''
    industries.forEach((item) => {
      if (item.slug === category) {
        label = item.label
      }
    })
    return `${label}`
  }
}

const handleSpecificLabelOffer = (dictionary, offerType) => {
  if (offerType === 'first_time') {
    return `${dictionary.TABS.modal_reward_type_first_time} x`
  } else {
    return `${dictionary.TABS.modal_reward_type_recurring} x`
  }
}

const handleInvexSpecificLabelOffer = (dictionary, offerType) => {
  if (offerType === 'first_time') {
    return `${dictionary.TABS.modal_bonification_type_first_time} x`
  } else {
    return `${dictionary.TABS.modal_bonification_type_recurring} x`
  }
}

const handleSpecificLabelBusiness = (dictionary, businessType) => {
  if (businessType === 'physicalVenue') {
    return `${dictionary.TABS.modal_business_type_physical} x`
  } else {
    return `${dictionary.TABS.modal_business_type_ecommerce} x`
  }
}

const handleSpecificLabelPrice = (dictionary, priceLevel) => {
  if (priceLevel === 1) {
    return '$ x'
  } else if (priceLevel === 2) {
    return '$$ x'
  } else if (priceLevel === 3) {
    return '$$$ x'
  } else {
    return '$$$$ x'
  }
}

export {
  INDUSTRIES_EN,
  INDUSTRIES_ES,
  SHORT_INDUSTRIES_EN,
  SHORT_INDUSTRIES_ES,
  handleSpecificLabelCategory,
  handleSpecificLabelOffer,
  handleInvexSpecificLabelOffer,
  handleSpecificLabelBusiness,
  handleSpecificLabelPrice
}

export const SORT = [
  { label: 'ASC', id: 0 },
  { label: 'DESC', id: 1 }
]
